import script from "./CreateApplication.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateApplication.vue?vue&type=script&setup=true&lang=js"

import "./CreateApplication.vue?vue&type=style&index=0&id=54a6330f&lang=scss&scoped=true"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a6330f"]])

export default __exports__